import { takeLatest, put, call } from 'redux-saga/effects';
import { CORE_API } from '../../config'
import {
    GET_ALERT_LIST,
    getAlertList,
    getAlertListFailure,
    getAlertListSuccess,
    GET_GENERAL_NEWS_LIST,
    getGeneralNewsListSuccess,
    getGeneralNewsListFailure,
    UPDATE_READ_STATUS,
    // updateReadStatusSuccess,
    updateReadStatusFailure
} from './action';
import { HTTP_HEADERS } from '../../constants';
import request from "../../components/Utils/httpHelper";

export function* alertList(action) {
    let requestURL = `${CORE_API}/alerts/portfolio/0/30`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'GET', headers: HTTP_HEADERS });
        yield put(getAlertListSuccess(result.data));
    } catch (err) {
        yield put(getAlertListFailure(err))
    }
}
export function* getAlertListSaga() {
    yield takeLatest(GET_ALERT_LIST, alertList);
}

export function* generalNewsList(action) {
    let requestURL = `${CORE_API}/alerts/general/0/30`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'GET', headers: HTTP_HEADERS });
        yield put(getGeneralNewsListSuccess(result.data));
    } catch (err) {
        yield put(getGeneralNewsListFailure(err))
    }
}
export function* getGeneralNewsListSaga() {
    yield takeLatest(GET_GENERAL_NEWS_LIST, generalNewsList);
}

export function* readStatus(action) {
    let requestURL = `${CORE_API}/alerts/${action.data}`;
    try {
        yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(getAlertList());
    } catch (err) {
        yield put(updateReadStatusFailure(err))
    }
}
export function* updateReadStatus() {
    yield takeLatest(UPDATE_READ_STATUS, readStatus);
}

